'use client';

import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface TaskDeleteModalProps {
  taskId: string;
  taskName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function TaskDeleteModal({
  taskName,
  onConfirm,
  onCancel,
}: TaskDeleteModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-foreground/30 backdrop-blur-sm"
        onClick={onCancel}
      />
      {/* Modal */}
      <div className="relative bg-card border border-border rounded-2xl shadow-card-lg w-full max-w-md p-6 fade-in">
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors btn-press"
        >
          <X size={18} />
        </button>

        <div className="flex items-start gap-4">
          <div className="h-10 w-10 rounded-xl bg-red-100 flex items-center justify-center shrink-0">
            <AlertTriangle size={20} className="text-red-600" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground">Delete Task</h3>
            <p className="text-sm text-muted-foreground mt-1">
              Are you sure you want to delete{' '}
              <span className="font-semibold text-foreground">"{taskName}"</span>? This action
              cannot be undone.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 mt-6">
          <button
            onClick={onCancel}
            className="h-9 px-4 rounded-lg border border-border text-sm font-medium text-foreground hover:bg-muted transition-colors btn-press"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="h-9 px-4 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition-colors btn-press"
          >
            Delete Task
          </button>
        </div>
      </div>
    </div>
  );
}